import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { Observable, of } from 'rxjs';
import { environment } from 'projects/access-control/src/environments/environment';
import { ApiService } from '../../Services/api.service';
import { Versions } from 'projects/access-control/src/app/Domain/Entities/versions.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';

@Injectable({
	providedIn: 'root',
})
export class SystemsModuleService {
	constructor(private api: ApiService, private http: HttpClient) {}

	getModule(page: number = 1) {
		return this.http.get<any>(`${environment.apiUrl}${'/system-modules'}?_size=10&_page=${page}`);
	}
	getAllModule() {
		return this.http.get<any>(`${environment.apiUrl}${'/system-modules'}?_size=false`);
	}

	getSearchModule(search: string) {
		return this.http.get<any>(`${environment.apiUrl}/system-modules/query?_name=${search}`);
	}

	createModule(data: Module): Observable<any> {
		return this.api.post('/system-modules/', data);
	}
	updateModule(pk: string, sk: string, data: Module): Observable<any> {
		return this.api.patch(`/system-modules/${pk}/${sk}`, data);
	}
	deleteModule(data: Module): Observable<any> {
		return this.api.delete(`/system-modules/${data.pk}/${data.sk}`, data);
	}

	createResourceModule(pk: string, sk: string, data: Resource): Observable<any> {
		return this.api.post('/resources/' + pk + '/' + sk, data);
	}
	getResource(url: string): Observable<any> {
		return this.http.get(url);
	}
	getResourceSearch(url: string, search: string = ''): Observable<any> {
		return this.http.get(url + search);
	}
	updateResourceModule(pk: string, sk: string, data: Resource): Observable<any> {
		return this.api.patch(`/resources/${pk}/${sk}`, data);
	}

	deleteResourcesModule(resources: IPkSk[], module: IPkSk): Observable<any> {
		return this.api.delete<any>(`/resources/${module.pk}/${module.sk}`, { body: { resources } });
	}

	getVersionModule(
		module: IPkSk,
		page: number
	): Observable<{ data: { versions: Versions[]; module: IPkSk }; pagination: Pagination }> {
		return this.api.get<{
			data: { versions: Versions[]; module: IPkSk };
			pagination: Pagination;
		}>(`/system-modules/${module.pk}/${module.sk}/versions?_page=${page}`);
	}

	postVersionModule(version: Versions, module: IPkSk): Observable<Versions> {
		return this.api.post<Versions>(`/versions`, {
			...version,
			modulePk: module.pk,
			moduleSk: module.sk,
		});
	}

	updateVersionModule(ids: IPkSk, version: Versions): Observable<any> {
		return this.api.patch(`/versions/${ids.pk}/${ids.sk}`, version);
	}

	deleteVersionModule(ids: IPkSk[], module: IPkSk): Observable<{ data: { versions: IPkSk[] } }> {
		return this.api.delete<{ data: { versions: IPkSk[] } }>(
			`/system-modules/${module.pk}/${module.sk}/versions`,
			{ body: { versions: ids } }
		);
	}
}
